import { configureStore } from "@reduxjs/toolkit";

import { dataReducer } from "./dataReducer";
import { layoutReducer } from "./layoutReducer";
import { entityFiltersReducer } from "./entityFiltersSlice";

export const store = configureStore({
  reducer: {
    data: dataReducer,
    layout: layoutReducer,
    entityFilters: entityFiltersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["layout/showJsonModal", "layout/addToast"],
        // Ignore these field paths in all actions
        ignoredActionsPaths: ["payload.actions"],
        // Ignore these paths in the state
        ignoredPaths: ["layout.jsonModal.actions", "layout.toasts"],
      },
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
